<template>
  <v-container fill-height fluid class="customize-view pb-0">
    <page-title title="Customize"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-container>
</template>

<script>
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
export default {
  name: 'CustomizeView',
  components: {
    Tabs
  },
  computed: {
    tabSettings: function() {
      const tabs = []
      const enabledMetrics = this.$store.getters['campaign/enabledMetrics']
      if (enabledMetrics.indexOf('NPS') > -1) {
        tabs.push({
          id: routes.SURVEY_CUSTOMIZE_NPS,
          label: 'NPS'
        })
      }
      if (enabledMetrics.indexOf('CSAT') > -1) {
        tabs.push({
          id: routes.SURVEY_CUSTOMIZE_CSAT,
          label: 'CSAT'
        })
      }
      if (enabledMetrics.indexOf('CES') > -1) {
        tabs.push({
          id: routes.SURVEY_CUSTOMIZE_CES,
          label: 'CES'
        })
      }
      return {
        preselected: null,
        tabs: tabs
      }
    }
  }
}
</script>

<style lang="stylus">
.customize-view {

}
</style>
